import { ElementHelpers } from '../helpers/element-helpers';
import { breakpoints } from '../helpers/constants';

export class Accordion {

	constructor(elem, options = {}) {
		this.elem = elem;
		this.options = options;
		this.headers = elem.querySelectorAll('[data-accordion-header]');
		this.propsSet = false;
		this.init();
	}

	static getSelector() {
		return '[data-accordion]';
	}

	get classNames() {
		return {
			'IS_EXPANDED': '_is-expanded'
		}
	}

	init() {
		this.addEventListeners();
		if(this.testBreakpoint()) {
			this.setAccessibilityProps();
		}
	}

	addEventListeners() {
		ElementHelpers.addEventListeners(this.headers, 'click', (event) => {
			if(this.testBreakpoint()) {
				this.toggle(event);
			}
		});
		window.addEventListener('orientationchange', this.setAccessibilityProps.bind(this));
		window.addEventListener('resize', this.setAccessibilityProps.bind(this));
	}

	toggle(event) {
		const header = event.currentTarget;
		const body = header.nextElementSibling;
		const parent = header.parentElement;
		parent.classList.toggle(this.classNames.IS_EXPANDED);
		header.setAttribute('aria-expanded', (parent.classList.contains(this.classNames.IS_EXPANDED)).toString());
		if(body) {
			if(body.style.maxHeight) {
				body.style.maxHeight = null;
				body.setAttribute('aria-hidden', 'true');
			} else {
				body.style.maxHeight = body.scrollHeight + 'px';
				body.setAttribute('aria-hidden', 'false');
			}
		}
	}

	setAccessibilityProps() {
		if(!this.propsSet && this.testBreakpoint()) {
			for(let i = 0; i < this.headers.length; i = i + 1) {
				const header = this.headers[i];
				const isActive = header.classList.contains(this.classNames.IS_EXPANDED);
				header.setAttribute('tabindex', '0');
				header.setAttribute('role', 'button');
				header.setAttribute('aria-expanded', isActive.toString());
				const body = header.nextElementSibling;
				if(body) {
					body.setAttribute('aria-hidden', (!isActive).toString());
				}
				this.propsSet = true;
			}
		} else if(this.propsSet && !this.testBreakpoint()) {
			for(let i = 0; i < this.headers.length; i = i + 1) {
				const header = this.headers[i];
				header.removeAttribute('tabindex');
				header.removeAttribute('role');
				header.removeAttribute('aria-expanded');
				const body = header.nextElementSibling;
				if(body) {
					body.removeAttribute('aria-hidden');
				}
				this.propsSet = false;
			}
		}
	}

	testBreakpoint() {
		let result;
		switch(this.options.breakpoint) {
			case 'isMedium':
				result = breakpoints.isMedium();
				break;
			default:
				result = true;
		}
		return result;
	}
}

